/* eslint-disable camelcase */
import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Icon from 'utils/icon';
import { useProduct } from './product-context';
import './add-to-cart-button.css';

const AddToCartButton = ({ children }) => {
  const { activeVariant, allProducts, activeProduct, hasChanged, stickyCTA } =
    useProduct();
  const [quantity, setQuantity] = useState(1);
  const productId = activeProduct.id.split('gid://shopify/Product/')[1];
  const variantId = parseInt(
    activeVariant.id.split('gid://shopify/ProductVariant/')[1],
    10,
  );

  useEffect(() => {
    if(!stickyCTA) return;

    handleStickyAtc();

    const cartBtn = document.getElementById('sticky-atc');
    const cookieBanner = document.getElementById('cookies-banner');
  
    function adjustButtonPosition() {
      if (!cartBtn || !cookieBanner) return;
  
      const cookieVisible = cookieBanner.style.display !== 'none' && cookieBanner.offsetHeight > 0;
  
      cartBtn.style.bottom = cookieVisible
        ? `${cookieBanner.offsetHeight - 2}px`
        : '0px';
    }
  
    adjustButtonPosition();
  
    document.addEventListener('cookieBannerClosed', adjustButtonPosition);
  
    const observer = new MutationObserver(adjustButtonPosition);
    if (cookieBanner) {
      observer.observe(cookieBanner, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  
    return () => {
      document.removeEventListener('cookieBannerClosed', adjustButtonPosition);
      observer.disconnect();
    };
  }, []);

  function handleStickyAtc() {
    const mainAtc = document.getElementById('main-atc');
    const stickyAtc = document.getElementById('sticky-atc');
    if (mainAtc.getBoundingClientRect().top < 0) {
      stickyAtc.classList.remove('translate-y-full');
      stickyAtc.classList.add('translate-y-0');
    } else {
      stickyAtc.classList.remove('translate-y-0');
      stickyAtc.classList.add('translate-y-full');
    }
  }
  
  if (stickyCTA) {
    window.addEventListener('scroll', handleStickyAtc);
  }
  

  window.Rise = {
    full_product: { available: true },
    is_floating_cart_theme: true,
    is_product_page: true,
    product: { id: '7806136221867' },
    using_add_to_cart_flow: false,
    onGiftAdded: ({ gift }) => {
      const { _gift_id, message, email, name } = gift;
      const properties = {
        _gift_id,
        message,
        name,
      };
      if (email) {
        properties.email = email;
      }
      const payload = {
        id: variantId,
        quantity,
        properties,
      };

      document.dispatchEvent(
        new CustomEvent('cart:add', {
          detail: {
            payload,
          },
        }),
      );
    },
  };

  if (!allProducts) return null;

  const handleAddToCart = () => {
    const payload = {
      id: variantId,
      quantity,
      properties: {
        'Preorder Disclaimer': activeVariant.preOrderDisclaimer?.value || '',
      },
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: Shopify.currency.active,
        value: activeVariant.price.amount,
        items: [
          {
            item_name: activeProduct.title,
            item_id: productId,
            price: activeVariant.price.amount,
            item_category: activeProduct.productType,
            quantity,
          },
        ],
      },
    });

    document.dispatchEvent(
      new CustomEvent('cart:add', {
        detail: {
          payload,
        },
      }),
    );
  };

  const handleBIS = () => {
    const payload = {
      product: activeProduct,
    };

    document.dispatchEvent(
      new CustomEvent('bis:add', {
        detail: {
          payload,
        },
      }),
    );
  };

  const handleRiseModal = () => {
    document
      .getElementsByClassName('Rise-popup-backdrop')[0]
      .classList.add('show');
    document.getElementsByClassName('Rise-popup')[0].classList.add('open');
  };

  const checkQuantity = (q) => {
    const availableQuantity = activeVariant.quantityAvailable;
    if (q < availableQuantity) {
      setQuantity(q);
    } else {
      availableQuantity <= 0 &&
      q <= +activeVariant.maxPreorderInventory?.value + availableQuantity
        ? setQuantity(q)
        : setQuantity(
            +activeVariant.maxPreorderInventory?.value + availableQuantity,
          );
    }
  };

  const atcButton = (sticky = false) => {
    if (!activeVariant) return null;
    return (<div className="flex items-center h-[50px] add-to-cart-button-container" id={sticky ? 'sticky-addtobag' : 'addtobag'}>
    {window.yotpo_bis === 'true' && (activeVariant.preorder === null || activeVariant.preorder.value === 'false') && activeVariant.quantityAvailable <= 0 && activeProduct.productType !== 'Accessories: Gift Card' ? (
        <div class="yotpo-back-in-stock-container flex w-full">
          <div
            class="mt-3 flex items-center justify-center cursor-pointer w-full text-center h-[50px] bg-[#474747] rounded-[3px] text-white"
            onClick={handleBIS}
          >
            Notify Me When Available
          </div>
        </div>) : (
        <>
         {!sticky && (
          <div className="flex items-center h-[50px] w-[95px] pl-[11px] border-1 border-text-1 rounded-tl-[6px] rounded-bl-[6px] add-to-cart-button-quantity-container">
            <button
              className="h-full cursor-pointer"
              onClick={() => {
                if (quantity > 1) setQuantity(quantity - 1);
              }}
            >
              <Icon id="minus" className="stroke-text-1" />
            </button>
            <input
              className="quantity-input text-center w-[40px] border-0 m-0 text-text-1 focus:!outline-none border-transparent focus:border-transparent focus:ring-0"
              type="number"
              id="quantity"
              name="quantity"
              min="1"
              value={quantity}
              onChange={(e) => checkQuantity(e.target.value)}
            />
            <button
              className="h-full cursor-pointer"
              onClick={() => checkQuantity(quantity + 1)}
            >
              <Icon id="plus" className="stroke-text-1" />
            </button>
          </div>
          )}
          <button
            id="atc-button"
            className={`${
              productId === '7806136221867' ? 'Rise-add-to-cart-button' : ''
            } ${
              !activeVariant.available ||
              (activeVariant.currentlyNotInStock == true &&
                activeVariant.preorder?.value == 'false' &&
                Math.abs(activeVariant.quantityAvailable) >=
                  +activeVariant.maxPreorderInventory?.value)
                ? 'bg-grey-300 border-l-0 text-grey-700'
                : 'bg-text-1 text-white'
            } grow self-stretch border-1 border-text-1 ${sticky ? 'rounded-[6px]' : 'rounded-tr-[6px] rounded-br-[6px]'} cursor-pointer`}
            onClick={() => handleAddToCart()}
            disabled={
              !activeVariant.available ||
              (activeVariant.currentlyNotInStock == true &&
                activeVariant.preorder?.value == 'false' &&
                Math.abs(activeVariant.quantityAvailable) >=
                  +activeVariant.maxPreorderInventory?.value)
            }
            data-action="add-to-cart"
          >
            {activeVariant.preorder?.value == 'true' &&
            activeVariant.currentlyNotInStock == true &&
            Math.abs(activeVariant.quantityAvailable) <=
              +activeVariant.maxPreorderInventory?.value
              ? 'Preorder'
              : activeVariant.preorder?.value == 'true' &&
                activeVariant.currentlyNotInStock == true &&
                Math.abs(activeVariant.quantityAvailable) >
                  +activeVariant.maxPreorderInventory?.value
              ? window.TMW.Strings.product.unavailable
              : activeVariant.available
              ? window.TMW.Strings.product.addToCart
              : window.TMW.Strings.product.unavailable}
          </button>
          {hasChanged ? (
            <button
              onClick={handleRiseModal}
              className="GiftWizard-gift-button bg-text-1 text-white grow self-stretch border-1 border-text-1 rounded-tr-[6px] rounded-br-[6px] cursor-pointer gwbutton"
            >
              Send as a Gift
            </button>
          ) : (
            ''
          )}
        </>)}
  </div>)
  }

  return (
    <>
      {activeVariant && (
        <div>
          <div id="main-atc">
            {atcButton()}
          </div>
          {stickyCTA && (
          <div id="sticky-atc" class="sticky-product-button fixed bottom-0 left-0 w-full z-40 ease-in-out duration-300 translate-y-full">
            <div class="overflow-hidden lg:px-[10px] lg:py-[10px] w-full lg:h-[94px] h-[64px] lg:rounded-t-lg  border-t lg:border-l lg:border-r lg:border-grey-B4 border-grey-D0 bg-white lg:flex lg:justify-between">
              <div class="flex-1 min-w-0 hidden lg:flex items-center">
                <img src={activeVariant.image.url} alt={activeProduct.title} class="w-auto h-full hidden md:block" data-sticky-image="" />
                <div class="body pl-3">{activeProduct.title.includes(':') ? activeProduct.title.split(':')[0] : activeProduct.title}</div>
                <div class="text-xs text-[#5C5C5C] flex">
                  {activeVariant.selectedOptions.length > 1 && (
                  <div class="flex" data-sticky-option-color="">
                    <div class="pl-5 pr-5">|</div>
                    <div data-sticky-option-color-value="">
                      {activeVariant.selectedOptions[1].name}: {activeVariant.selectedOptions[1].value}
                    </div>
                  </div>
                  )}
                  {activeVariant.selectedOptions.length > 0 && (
                  <div class="flex" data-sticky-option-size="">
                    <div class="pl-5 pr-5">|</div>
                    <div data-sticky-option-size-value="">{activeVariant.selectedOptions[0].name}: {activeVariant.selectedOptions[0].value}</div>
                  </div>
                  )}
                </div>
              </div>
              <div class="[&_button]:lg:w-[366px] [&_button]:h-[44px] [&_button]:w-full p-2.5 lg:pr-5 lg:py-[15px]">
                {atcButton(true)}
              </div>
            </div>
          </div>
          )}
        </div>
      )}
    </>
  );
};

export default AddToCartButton;
